import React from "react";

const BackgroundGlow = React.memo(function BackgroundGlow() {
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none fixed inset-0 z-[-1] overflow-hidden"
    >
      {/* Base atmospheric gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.025),transparent_65%)]" />

      {/* Primary yellow glow */}
      <div
        className="
          absolute
          -left-[15%] -top-[20%]
          h-[500px] w-[500px]
          sm:h-[650px] sm:w-[650px]
          lg:h-[800px] lg:w-[800px]
          rounded-full
          bg-yellow-400/20
          blur-[100px]
          sm:blur-[130px]
          mix-blend-screen
          animate-[pulse_8s_ease-in-out_infinite]
        "
      />

      {/* Secondary warm glow */}
      <div
        className="
          absolute
          left-[15%] top-[5%]
          h-[250px] w-[250px]
          rounded-full
          bg-amber-300/10
          blur-[90px]
          mix-blend-screen
          animate-[pulse_11s_ease-in-out_infinite]
        "
      />

      {/* Primary blue glow */}
      <div
        className="
          absolute
          -bottom-[20%] -right-[15%]
          h-[500px] w-[500px]
          sm:h-[650px] sm:w-[650px]
          lg:h-[800px] lg:w-[800px]
          rounded-full
          bg-blue-600/20
          blur-[100px]
          sm:blur-[130px]
          mix-blend-screen
          animate-[pulse_10s_ease-in-out_infinite]
        "
      />

      {/* Cyan accent */}
      <div
        className="
          absolute
          bottom-[15%] right-[20%]
          h-[250px] w-[250px]
          rounded-full
          bg-cyan-400/10
          blur-[90px]
          mix-blend-screen
          animate-[pulse_13s_ease-in-out_infinite]
        "
      />

      {/* Center atmospheric glow */}
      <div
        className="
          absolute
          left-1/2 top-1/2
          h-[350px] w-[350px]
          -translate-x-1/2 -translate-y-1/2
          rounded-full
          bg-violet-500/[0.04]
          blur-[120px]
        "
      />

      {/* Subtle grid */}
      <div
        className="
          absolute inset-0
          opacity-[0.035]
          [background-image:linear-gradient(rgba(255,255,255,0.5)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.5)_1px,transparent_1px)]
          [background-size:64px_64px]
          [mask-image:radial-gradient(ellipse_at_center,black,transparent_80%)]
        "
      />

      {/* Vignette */}
      <div
        className="
          absolute inset-0
          bg-[radial-gradient(ellipse_at_center,transparent_20%,rgba(0,0,0,0.35)_100%)]
        "
      />

      {/* Noise-like texture */}
      <div
        className="
          absolute inset-0
          opacity-[0.025]
          mix-blend-overlay
          bg-[url('data:image/svg+xml,%3Csvg viewBox=%220 0 180 180%22 xmlns=%22http://www.w3.org/2000/svg%22%3E%3Cfilter id=%22n%22%3E%3CfeTurbulence type=%22fractalNoise%22 baseFrequency=%220.8%22 numOctaves=%224%22 stitchTiles=%22stitch%22/%3E%3C/filter%3E%3Crect width=%22100%25%22 height=%22100%25%22 filter=%22url(%23n)%22 opacity=%22.7%22/%3E%3C/svg%3E')]
        "
      />
    </div>
  );
});

export default BackgroundGlow;
